import "./App.css";
import "./style.css";
import "./components/first-page.css";
import "./components/second-page.css";
import "./components/third-page.css";

function App() {
  return (
    <div className="container">
      <div className="page first-page">
        <div className="menu-container">
          <h1 className="menu-text"> Meny </h1>
        </div>
        <div className="peter-groning-name-container">
          <h1 className="peter-groning-name"> Peter Gröning</h1>
        </div>
      </div>
      <div className="page second-page">
      <div className="second-page__text-container"> 
        <p className="second-page__text">
          {" "}
          My name is Peter Gröning. I'm a actor, singer, and mentalist.
        </p>
        </div>
        <div className="second-page__text-container"> 
        <p className="second-page__text">
          {" "}
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
          ac dolor quis dui sodales fringilla ut eu nibh. Fusce vel sem
          sollicitudin, ultricies mi et, interdum sapien. Fusce diam ante,
          egestas a dolor viverra, vestibulum aliquam libero. Phasellus aliquam
          magna eu mauris interdum, sit amet aliquam diam finibus. Pellentesque
          tempus urna velit. Sed et ligula ornare, iaculis ligula at, convallis
          mauris. Nullam aliquam augue in eros mollis, id commodo risus
          elementum.{" "}
        </p>
        </div>
        <div className="second-page__text-container"> 
        <p className="second-page__text">
          {" "}
          Aliquam auctor metus leo, ac convallis eros sagittis ac. Suspendisse
          cursus massa placerat convallis placerat. Fusce vel leo vel felis
          mollis vehicula. Aenean ex nulla, suscipit sit amet rutrum at, blandit
          quis turpis. Vestibulum pharetra, magna ut dapibus eleifend, mi nisl
          mattis leo, sollicitudin mattis dui dui in turpis
        </p>
        </div>
      </div>

      <div className="page third-page">
        <h1 className="show-reel"> Show reel</h1>
        <div className="movie">
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/kOHkoGV9qps?controls=0"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>{" "}
        </div>
        <div className="movie">
          {" "}
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/pJjfBW6ZFz4?controls=0"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div className="movie">
          {" "}
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/SvdfneaEhNY?controls=0"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>{" "}
        </div>
        <div className="movie">
          {" "}
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/hopkdN1F9Gg"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>{" "}
        </div>
      </div>
    </div>
  );
}
export default App;
